<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Company No：{{
            formData.ecomCompanyNo ? formData.ecomCompanyNo : 'New'
          }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="formData.ecomCompanyStatus === 'Y'
              ? 'success'
              : formData.ecomCompanyStatus === 'N'
              ? 'danger'
              : 'primary'"
        >
          {{ formData.v_ecomCompanyStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyDate ? formData.modifyDate : '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_ecomCompanyName') || '公司名称'"
            prop="ecomCompanyName"
          >
            <el-input
              v-model="formData.ecomCompanyName"
              clearable
              size="small"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="4000"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_ecomCompanyNameEn') || '公司英文名称'"
          >
            <el-input
              v-model="formData.ecomCompanyNameEn"
              clearable
              size="small"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="4000"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item :label="$l('form_label_regionName') || '国家名称'">
            <dict-select
              filterable
              size="small"
              clearable
              v-model="formData.regionCode"
              :selectedLabel.sync="formData.regionName"
              :body="regionParams"
              url="/master/common/dict/biz"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_Provinces_cities_counties') || '省市区县'"
          >
            <region-cascader
              :show="regionShow"
              :provinceCode.sync="formData.provinceCode"
              :provinceName.sync="formData.provinceName"
              :cityCode.sync="formData.cityCode"
              :cityName.sync="formData.cityName"
              :districtCode.sync="formData.districtCode"
              :districtName.sync="formData.districtName"
              size="small"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_companyAddress') || '详细地址'">
            <el-input
              v-model="formData.companyAddress"
              clearable
              size="small"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="500"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_companyAddressEn') || '英文地址'"
          >
            <el-input
              v-model="formData.companyAddressEn"
              clearable
              size="small"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="500"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-form-item :label="$l('form_label_bankAccountType') || '账户性质'">
            <el-select
              clearable
              v-model="formData.bankAccountType"
              size="small"
              style="width:100%"
            >
              <el-option
                :label="$l('form_label_bankAccountType_company') || '公司'"
                value="0"
              ></el-option>
              <el-option
                :label="$l('form_label_bankAccountType_personal') || '个人'"
                value="1"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item :label="$l('form_label_bankAccountKind') || '账号类别'">
            <el-select
              clearable
              v-model="formData.bankAccountKind"
              size="small"
              style="width:100%"
            >
              <el-option
                :label="$l('form_label_bankAccountKind_rmb') || '人民币'"
                value="0"
              ></el-option>
              <el-option
                :label="$l('form_label_bankAccountKind_foreign') || '外币'"
                value="1"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_bankName') || '开户银行'">
            <el-input
              v-model="formData.bankName"
              clearable
              size="small"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_bankAccountName') || '账户名称'">
            <el-input
              v-model="formData.bankAccountName"
              clearable
              size="small"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_bankAccountNo') || '银行账号'">
            <el-input
              v-model="formData.bankAccountNo"
              clearable
              size="small"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$l('form_label_remark') || '备注说明'">
            <el-input
              type="textarea"
              v-model="formData.remark"
              clearable
              size="small"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              rows="3"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import {mapActions} from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    ecomCompanyCode: {type: String, default: ''},
    disabled: {type: Boolean, default: true},
  },
  data() {
    return {
      regionParams: {dictType: 'region'},
      regionShow: false,
      formData: {},
      rules: {
        ecomCompanyName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
    this.regionShow = true
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.ecomCompanyCode) return
      this.$api
        .ecomCompanyDetailApi({
          ecomCompanyCode: this.ecomCompanyCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      this.loadingOpen()

      this.$api
        .ecomCompanySaveApi(this.formData)
        .then(async (res) => {
          this.loadingClose()
          const {status} = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          if (!this.ecomCompanyCode) {
            this.closeCurPage()
          } else {
            this.getData()
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
